import React, { Component, Fragment } from 'react';
import { Chart, ChartEditorOptions } from '../../../domain/chart/ChartDomains';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { RootState } from '../../../redux/store';
import { ChartState } from '../../../redux/reducers/ChartReducer';
import { PageState } from '../../../redux/reducers/PageReducer';
import { changeChart, changeChartResponse, changeIsUpdate, changeLoading, clearChart } from '../../../redux/actions/ChartActions';
import { enterComponent, leaveComponent } from '../../../redux/actions/ComponentActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import ChartService from '../../../service/ChartService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import { ConfirmPopup } from 'primereact/confirmpopup';
import ChartEditorComponent from './ChartEditorComponent';
import { ChartType } from '@trlogic/ui-pack';
import LanguageUtil from '../../../util/LanguageUtil';

class ChartInformationComponent extends Component<Props> {
  private chartService: ChartService = ServiceContainer.getInstance().get(ServiceNames.CHART);

  render() {
    const {
      chart: { chart, loading },
    } = this.props;
    return (
      <Fragment>
        <ConfirmPopup />
        <ChartEditorComponent
          title={chart.name as string}
          description={chart.description as string}
          icon={this.getChartIcon(chart.type || ChartType.LINE)}
          onChangeTitle={this.onChangeChartName}
          onChangeDescription={this.onChangeChartDescription}
          onSave={() => this.saveChart()}
          loading={loading}
          onRemove={(e) => this.removeChart(e)}
        />
      </Fragment>
    );
  }

  public async componentDidMount() {
    const {
      chart: { chart, chartEditorOptions, chartResponse },
      changeChartResponse,
      isUpdate,
    } = this.props;
    if (isUpdate) {
      const response = await this.chartService.simulate(chart as Chart, chartEditorOptions as ChartEditorOptions);
      changeChartResponse(response);
    }
  }

  private getChartIcon(chartType: ChartType): string {
    switch (chartType) {
      case ChartType.BAR_VERTICAL_STACKED:
        return 'bar-vertical-chart';
      case ChartType.BAR_HORIZONTAL_STACKED:
        return 'bar-horizontal-chart';
      case ChartType.BAR_HORIZONTAL_ROWED:
        return 'bar-horizontal-chart';
      case ChartType.BAR_VERTICAL_ROWED:
        return 'bar-vertical-chart';
      case ChartType.PIE:
        return 'pie-chart';
      case ChartType.DONUT:
        return 'donut-chart';
      case ChartType.AREA:
        return 'area-chart';
      case ChartType.LINE:
        return 'line-chart';
      default:
        return 'bar-vertical-chart';
    }
  }

  private onChangeChartName = (value: string) => {
    const {
      chart: { chart },
      changeChart,
      isUpdate,
    } = this.props;
    chart.name = value;
    if (!isUpdate) chart.id = value as string;
    changeChart(chart);
    return;
  };
  private onChangeChartDescription = (value: string) => {
    const {
      chart: { chart },
      changeChart,
    } = this.props;
    chart.description = value;
    changeChart(chart);
  };

  private saveChart = async () => {
    const {
      chart: { chart, chartEditorOptions, isUpdate, loading },
      changeIsUpdate,
      router,
    } = this.props;
    const { setChartVersion, chartVersion, changeLoading } = this.props;
    if (loading) return;
    try {
      changeLoading(true);
      const { dashboard } = router.params;
      chart.dashboardId = dashboard as string;
      const chartId = await this.chartService.save(chart.name as string, chart as Chart, chartEditorOptions as ChartEditorOptions, isUpdate);
      setChartVersion(chartVersion + 1);
      if (!isUpdate) {
        this.switchToUpdate(chartId);
        changeIsUpdate(true);
      }
      changeLoading(false);
    } catch (e) {
      console.log('Error while saving chart', e);
    }
  };
  private removeChart = async (e: any) => {
    const {
      chart: { chart },
      router: { navigate },
    } = this.props;
    customConfirm({
      message: LanguageUtil.get({ id: 'messages.confirm.deleteChart', defaultMessage: 'Are you sure you want to delete this chart?' }),
      target: e.currentTarget,
      accept: async () => {
        await this.chartService.remove(chart.name as string);
        navigate(`/dashboard`);
      },
    });
  };
  private switchToUpdate = (name: string) => {
    if (name == '' || !name) return;
    const {
      router: { navigate },
    } = this.props;
    const { dashboard } = this.props.router.params;
    navigate(`/dashboard/${dashboard}/${name}`);
  };
}

interface Props extends ReduxProps, FormicaProps {
  setChartVersion: (chartVersion: number) => void;
  chartVersion: number;
}

const mapStateToProps = (state: RootState) => ({
  chart: state.chart as ChartState,
  isUpdate: state.chart.isUpdate,
  page: state.page as PageState,
});

const mapDispatchToProps = { changeChart, changeLoading, changeIsUpdate, changeChartResponse, enterComponent, leaveComponent, clearChart };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(ChartInformationComponent));
